/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 */

// document.addEventListener('variant:changed', function(event) {
//     var variant = event.detail.variant;

//   });

/* You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function() {
    /**
     *
     */
    var variantProductRecommendations = document.querySelector('[data-section-id="product-recos-for-variant"]');
    var variantProductRecommendationCarousels = variantProductRecommendations && variantProductRecommendations.querySelectorAll('.Carousel');

    if (variantProductRecommendationCarousels && variantProductRecommendationCarousels.length > 0) {
        var hasVariantProductRecommendations = false;

        variantProductRecommendationCarousels.forEach(function(carousel) {
            if (carousel.style.display !== 'none') {
                hasVariantProductRecommendations = true;
                new Flickity(carousel, JSON.parse(carousel.dataset.flickityConfig));
            }
        });

        if (!hasVariantProductRecommendations) {
            variantProductRecommendations.style.display = 'none';
        }

        /**
         *
         */
        window.addEventListener('change', function(event) {
            if (event && event.target && event.target.classList.contains('ColorSwatch__Radio')) {
                var variantId = new URL(document.URL).search.match(/^\?variant=([0-9]+)/);

                if (variantId.length > 1) {
                    hasVariantProductRecommendations = false;

                    variantProductRecommendationCarousels.forEach(function(carousel) {
                        if (carousel.dataset.variantId === variantId[1]) {
                            variantProductRecommendations.style.display = 'block';
                            hasVariantProductRecommendations = true;
                            carousel.style.display = 'block';
                            new Flickity(carousel, JSON.parse(carousel.dataset.flickityConfig));
                        } else {
                            carousel.style.display = 'none';
                        }
                    });

                    if (!hasVariantProductRecommendations) {
                        variantProductRecommendations.style.display = 'none';
                    }
                }
            }
        });
    }

    /**
     *
     */
    var colorSwatchList = document.querySelector('.Product__Info .ColorSwatchList');

    if (colorSwatchList) {
        var productImages = document.querySelectorAll('.Product__Gallery .Product__SlideItem');
        var productImageDots = document.querySelectorAll('.Product__Gallery .Product__SlideshowNavDot');
        var productImageThumbnails = document.querySelectorAll('.Product__Gallery .Product__SlideshowNavImage');
        var productMobileImageDots = document.querySelectorAll('.Product__Gallery .Product__SlideshowMobileNav .dot');

        var selectedSwatch = colorSwatchList.querySelector('.ColorSwatch__Radio[checked] + label');

        if (selectedSwatch) {
            window.setTimeout(function() {
                selectedSwatch.click(); // hack to get products w/ color + size options to initially display a selected variant's images
            }, 1000);
        }

        /**
         *
         */
        function toggleProductImagesForSwatchName(swatchName, variantId) {
            var hasSelectedForIndex = [];

            [productImages, productImageDots, productImageThumbnails, productMobileImageDots].forEach(function(images, imagesIndex) {
                images.forEach(function(image) {
                    if (image.getAttribute('data-variant-name').trim().toLowerCase() === swatchName) {
                        if (image.classList.contains('dot')) {
                            image.style.setProperty('display', 'inline-block', 'important');
                        } else {
                            image.style.setProperty('display', 'block', 'important');
                        }

                        if (!hasSelectedForIndex[imagesIndex]) {
                            image.classList.add('is-selected');
                            hasSelectedForIndex[imagesIndex] = true;
                        }
                    } else {
                        image.style.setProperty('display', 'none', 'important');
                        image.classList.remove('is-selected');
                    }
                });
            });
        }

        colorSwatchList.addEventListener('click', function(event) {
            if (event.target.tagName === 'INPUT' && event.target.value.length > 0) {
                toggleProductImagesForSwatchName(event.target.value.trim().toLowerCase());
            }
        });
    }

    /**
     *
     */
    var productLifestyleImagesCarousel = document.querySelector('[data-section-id="product-lifestyle-images"] .Carousel');

    if (productLifestyleImagesCarousel) {
        new Flickity(productLifestyleImagesCarousel, JSON.parse(productLifestyleImagesCarousel.dataset.flickityConfig));
    }

    /**
     *
     */
    var splitscreenSlideshow = document.querySelector('.SplitscreenSlideshow');

    if (splitscreenSlideshow) {
        var splitscreenSlides = splitscreenSlideshow.querySelectorAll('.SplitscreenSlideshow__Slide');

        if (splitscreenSlides.length > 0) {
            var splitscreenSlideImages = splitscreenSlideshow.querySelectorAll('.SplitscreenSlideshow__ImageContainer.hidden-phone');
            var splitscreenSlideImageShades = splitscreenSlideshow.querySelectorAll('.SplitscreenSlideshow__ImageContainer.hidden-phone .SplitscreenSlideshow__ImageShade');

            var splitscreenSlideHeight = splitscreenSlides[0].offsetHeight;
            var splitscreenSlideshowRect = splitscreenSlideshow.getBoundingClientRect();
            var splitscreenSlideshowStartY = windowScrollY + splitscreenSlideshowRect.top;
            var splitscreenSlideshowEndY = splitscreenSlideshowStartY + (splitscreenSlideHeight * (splitscreenSlides.length - 1));

            var splitscreenSlidePositionInView = 0;
            var lastSplitscreenSlidePositionInView = 0;

            var isResizeTicking = false;
            var isScrollTicking = false;

            var windowScrollY = window.scrollY;

            /**
             *
             */
            function resizeSplitscreenSlideshow(windowScrollY) {
                if (splitscreenSlideImages.length !== splitscreenSlides.length) {
                    return false;
                }

                splitscreenSlideHeight = splitscreenSlides[0].offsetHeight;

                splitscreenSlideshowRect = splitscreenSlideshow.getBoundingClientRect();
                splitscreenSlideshowStartY = windowScrollY + splitscreenSlideshowRect.top;
                splitscreenSlideshowEndY = splitscreenSlideshowStartY + (splitscreenSlideHeight * (splitscreenSlides.length - 1));

                if (windowScrollY >= splitscreenSlideshowStartY && windowScrollY < splitscreenSlideshowEndY) {
                    splitscreenSlidePositionInView = Math.floor((windowScrollY - splitscreenSlideshowStartY) / splitscreenSlideHeight);
                }

                // setup slides when browser loads in the middle of or past the slideshow
                if (windowScrollY >= splitscreenSlideshowStartY) {
                    splitscreenSlides.forEach(function(slide, index) {
                        var slideTargetHeight = 0;
                        var slideRectTop = slide.getBoundingClientRect().top;

                        if (splitscreenSlideHeight - slideRectTop > splitscreenSlideHeight) {
                            slideTargetHeight = 100;
                        } else {
                            slideTargetHeight = ((splitscreenSlideHeight - slideRectTop) / splitscreenSlideHeight) * 100;
                        }

                        splitscreenSlideImages[index].style.height = slideTargetHeight + '%';
                    });
                }
            }

            /**
             *
             */
            function scrollSplitscreenSlideshow(windowScrollY) {
                if (splitscreenSlideImages.length !== splitscreenSlides.length) {
                    return false;
                }

                if (splitscreenSlidePositionInView !== lastSplitscreenSlidePositionInView) {
                    if (splitscreenSlidePositionInView > lastSplitscreenSlidePositionInView) {
                        if (lastSplitscreenSlidePositionInView > 0) {
                            splitscreenSlideImages[lastSplitscreenSlidePositionInView].style.height = '100%';
                        }

                        if (splitscreenSlidePositionInView < splitscreenSlides.length) {
                            splitscreenSlideImageShades[splitscreenSlidePositionInView].style.opacity = 0;
                        }
                    } else {
                        if (lastSplitscreenSlidePositionInView < splitscreenSlides.length) {
                            splitscreenSlideImages[lastSplitscreenSlidePositionInView].style.height = '0%';
                        }

                        if (splitscreenSlidePositionInView > 0) {
                            splitscreenSlideImageShades[splitscreenSlidePositionInView - 1].style.opacity = 0.5;
                        }
                    }

                    lastSplitscreenSlidePositionInView = splitscreenSlidePositionInView;
                }

                if (windowScrollY >= splitscreenSlideshowStartY && windowScrollY < splitscreenSlideshowEndY) {
                    if (splitscreenSlideshow.getAttribute('data-splitscreen') !== 'active') {
                        splitscreenSlideshow.setAttribute('data-splitscreen', 'active');
                    }

                    splitscreenSlidePositionInView = Math.ceil((windowScrollY - splitscreenSlideshowStartY) / splitscreenSlideHeight);


                    if (splitscreenSlidePositionInView > 0 && splitscreenSlidePositionInView < splitscreenSlides.length) {
                        var revealPercentage = (((windowScrollY - splitscreenSlideshowStartY) % splitscreenSlideHeight) / splitscreenSlideHeight) * 100;

                        splitscreenSlideImages[splitscreenSlidePositionInView].style.height = revealPercentage + '%';
                        splitscreenSlideImageShades[splitscreenSlidePositionInView - 1].style.opacity = Math.floor(revealPercentage) * 0.005;
                    }
                } else {
                    if (splitscreenSlideshow.getAttribute('data-splitscreen') !== 'ready') {
                        splitscreenSlideshow.setAttribute('data-splitscreen', 'ready');
                        splitscreenSlidePositionInView = Math.ceil((windowScrollY - splitscreenSlideshowStartY) / splitscreenSlideHeight);
                    }
                }
            }

            resizeSplitscreenSlideshow(windowScrollY);
            scrollSplitscreenSlideshow(windowScrollY);

            /**
             *
             */
            window.addEventListener('resize', function() {
                windowScrollY = window.scrollY;

                if (!isResizeTicking) {
                    window.requestAnimationFrame(function() {
                        resizeSplitscreenSlideshow(windowScrollY);
                        isResizeTicking = false;
                    });
                }

                isResizeTicking = true;
            });

            /**
             *
             */
            window.addEventListener('scroll', function() {
                windowScrollY = window.scrollY;

                if (!isScrollTicking) {
                    window.requestAnimationFrame(function() {
                        scrollSplitscreenSlideshow(windowScrollY);
                        isScrollTicking = false;
                    });
                }

                isScrollTicking = true;
            });
        }
    }
})();


document.addEventListener('variant:changed', function(event) {

    var variant = event.detail.variant;

    var cp = variant.compare_at_price;
    var np = variant.price;

    if (cp > np) {

        // show the badge

        document.getElementById('custom-final-sale-test').style.display = 'block'

    } else {

        //hide the badge

        document.getElementById('custom-final-sale-test').style.display = 'none';
    }

    document.getElementById('in').style.display = 'none';

    document.getElementById('out').style.display = 'none';

    document.getElementById('lowst').style.display = 'none';

    document.getElementById('ost').style.display = 'none';



    if (variant['available']) {


        if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {

            document.getElementById('in').style.display = 'block';

            document.getElementById('lowst').style.display = 'block';


        }


    } else {

        document.getElementById('out').style.display = 'block';

        document.getElementById('ost').style.display = 'block';


    }

});

document.addEventListener('product:added', function(event) {
    var vid = event.detail.variant.featured_image.product_id;
    const prev_id=event.detail.variant.id;
    var vtitle = event.detail.variant.title;
    console.log("Added Item TItle"+vtitle);
   const already_added_items=document.querySelectorAll("#sidepros .column_flex");
      already_added_items.forEach(item=>{
        if(parseInt(item.dataset.vid)==prev_id)item.remove();
  })
    setTimeout(function() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            async: false,
            success: function(cart) {
             
                                              
                if (cart.items.length == 1) {
                    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + vid + "&limit=100&intent=related")
                        .then(response => response.json())
                        .then(({
                            products
                        }) => {
                            if (products.length > 0) {
                                console.log(products);
                                var krr = [];
                                var count = 0;
                                const firstRecommendedProduct = products[0];
                                for (var i = 0; i < products.length; i++) {
                                    var vrs = products[i].variants;
                                    var url = products[i].url;
                                    url = url.split('?')[0];
                                    url = url + '?variant=';
                                    var prot = products[i].title;
                                    for (var j = 0; j < vrs.length; j++) {
                                        if (vrs[j].title == vtitle) {
                                          if(vrs[j].available){
                                            krr[count] = vrs[j];
                                            count = count + 1;
                                            krr[count] = url;
                                            count = count + 1;
                                            krr[count] = prot;
                                            count = count + 1;
                                            var mid = vrs[j].id;
                                            url = url + mid;
                                            var mprice = vrs[j].price;
                                            mprice = parseFloat(mprice) / 100;
                                            mprice = ' $' + mprice.toFixed(2);
                                            var mtitle = vrs[j].title;
                                            var msrc = vrs[j].featured_image.src;

                                            var check = 0;
                                            var mcheck = 0;

                                            var cd = $('#sidepros').find('.column_flex');
                                            for (var x = 0; x < cd.length; x++) {
                                                var test = $(cd[x]).attr('data-vid');
                                                if (test == mid) {
                                                    check = 1;
                                                }
                                            }

                                            var cm = $('#cst-recoms').find('.column_flex');
                                            for (var y = 0; y < cm.length; y++) {
                                                if ($(cm[y]).attr('data-vid') == mid) {
                                                    mcheck = 1;
                                                }
                                            }

                                            if (mcheck == 0) {
                                                $('#cst-recoms').prepend('<div data-vid="' + mid + '" class="column_flex"><div class="image_wrap"><img class="recom_1" src="' + msrc + '"></div><div class="cust_recom_content_mob"><a href="' + url + '" ><p class="mp-title" >' + prot + '</p><p class="mv-title">' + mtitle + '</p></a><p class="p_price"></p><button type="button" class="rpbtn" data-url="' + url + '" data-price="' + mprice + '" data-title="' + mtitle + '" data-img="' + msrc + '" data-pid="' + mid + '" data-vart="" data-vid="' + mid + '">ADD . ' + ' ' + mprice + '</button></div></div>');
                                                
                                              
                                            }
                                            if (check == 0) {
                                                $('#sidepros').prepend('<div data-vid="' + mid + '" class="column_flex"><div class="image_wrap"><img class="recom_1" src="' + msrc + '"></div><div class="cust_recom_content_mob"><a href="' + url + '" ><p class="mp-title" >' + prot + '</p><p class="mv-title">' + mtitle + '</p></a><p class="p_price"></p><button type="button" class="rpbtn" data-url="' + url + '" data-price="' + mprice + '" data-title="' + mtitle + '" data-img="' + msrc + '" data-pid="' + mid + '" data-vart="" data-vid="' + mid + '">ADD . ' + ' ' + mprice + '</button></div></div>');
                                                
                                            }
                                        }
                                      }
                                    }
                                }
                               keepadd(krr);
                              console.log("KRR: ",krr);
                            }
                        });
                }
            }
        })
    }, 4000);
  /*
    setTimeout(function() {
        $('.rpbtn').click(function() {
            var vid = $(this).attr('data-vid');
            data = {
                "id": vid,
                "quantity": 1
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function() {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                }
            });
        })
    }, 6000);*/

});


setInterval(function() {
    var val = $('.custom_price_text').html();

    function calculateProgress(currentVal, targetVal) {
        var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
        var progressNum = document.querySelectorAll('.cart-shipping__num');
        var progressOuter = document.querySelectorAll('.cart-shipping__numOuter, .bar_hide');
        var successMsg = document.querySelectorAll('.cart-shipping__success');
        var result = Math.round(100 * currentVal / targetVal);
        progressBar.forEach(function(el) {
            el.setAttribute('style', "width: ".concat(result, "%"));
        })
        var newProgressNum = (targetVal - currentVal) / 100;
        if (newProgressNum <= 0) {
            progressNum.forEach(function(el) {
                el.textContent = newProgressNum;
            });
            progressOuter.forEach(function(el) {
                el.style.display = 'none';
            });
            successMsg.forEach(function(el) {
                el.style.display = 'block';
            });

        } else {

            progressNum.forEach(function(el) {
                el.textContent = newProgressNum;
            });

            successMsg.forEach(function(el) {
                el.style.display = 'none';
            });
            progressOuter.forEach(function(el) {
                el.style.display = 'block';
            });

        }
    };

    fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
            calculateProgress(data.total_price, val);
        });
}, 1000);

/*
function keepadd(vrs) {
    setInterval(function() {
      console.log("keepadd")
        if ($('#cst-recoms .column_flex').length == 0) {
            for (var j = 0; j < vrs.length; j++) {
                var mid = vrs[j].id;
                var mprice = vrs[j].price;
                mprice = parseFloat(mprice) / 100;
                mprice = ' $' + mprice.toFixed(2);
                var mtitle = vrs[j].title;
                var msrc = vrs[j].featured_image.src;
                j = j + 1;
                var url = vrs[j]
                url = url + mid;
                j = j + 1;
                var prot = vrs[j];

                var mcheck = 0;

                var cm = $('#cst-recoms').find('.column_flex');
                for (var y = 0; y < cm.length; y++) {
                    if ($(cm[y]).attr('data-vid') == mid) {
                        mcheck = 1;
                    }
                }
                if (mcheck == 0) {
                    $('#cst-recoms').prepend('<div data-vid="' + mid + '" class="column_flex"><div class="image_wrap"><img class="recom_1" src="' + msrc + '"></div><div class="cust_recom_content_mob"><a href="' + url + '" ><p class="mp-title" >' + prot + '</p><p class="mv-title">' + mtitle + '</p></a><p class="p_price"></p><button type="button" class="rpbtn" data-url="' + url + '" data-price="' + mprice + '" data-title="' + mtitle + '" data-img="' + msrc + '" data-pid="' + mid + '" data-vart="" data-vid="' + mid + '">ADD . ' + ' ' + mprice + '</button></div></div>');
                }
            }
        }
          setTimeout(function() {
            $('.rpbtn').click(function() {
                var vid = $(this).attr('data-vid');
                data = {
                    "id": vid,
                    "quantity": 1
                }
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    dataType: 'json',
                    success: function() {
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true
                        }));
                    }
                });
            })
        }, 2000);

    }, 1000);
}*/